import dayjs from "dayjs";
import i18n from "../../core/i18n";

/**
 * Formats a date+time with a locale-aware connector word ("at" / "o" / "v").
 * dayjs handles locale-aware day/month names via the global locale set in i18n.ts.
 *
 * @param date   - ISO string or Date object
 * @param includeDay - whether to include abbreviated weekday name (e.g. "Tue")
 * @returns formatted string like "Mar 3, 2025 at 14:37" or "Tue, Mar 3, 2025 at 14:37"
 */
export const formatDateTimeAt = (date: string | Date, includeDay = false): string => {
  const d = dayjs(date);
  const connector = i18n.t("common:dateTimeConnector");
  if (includeDay) {
    return `${d.format("ddd, MMM D, YYYY")} ${connector} ${d.format("HH:mm")}`;
  }
  return `${d.format("MMM D, YYYY")} ${connector} ${d.format("HH:mm")}`;
};
